interface BorderConfig {
  borders: Array<{position: string, color: string}>;
  corners: Array<{position1: string, position2: string, color: string}>;
  tips: Array<{position1: string, position2: string, color: string}>;
  number: string;
}

class BorderContainer {
  constructor() {
    this.init();
  }

  init() {
    const containers = document.querySelectorAll('.borders-container[data-borders]');
    containers.forEach(container => this.processContainer(container as HTMLElement));
  }

  private processContainer(container: HTMLElement): void {
    const config = this.parseBorderConfig(container.dataset.borders || '');
    this.createBorders(container, config.borders);
    this.createCornerBlocks(container, config.corners);
    this.createBorderTips(container, config.tips);
    this.createNumber(container, config.number);
  }

  private parseBorderConfig(configString: string): BorderConfig {
    const config: BorderConfig = {
      borders: [],
      corners: [],
      tips: [],
      number: ''
    };

    configString = configString.replace(/\s+/g, '');

    const sections = configString.split(';');
    
    sections.forEach(section => {
      const [type, values] = section.split(':');
      if (!values) return;

      const items = values.split(',');
      
      switch(type) {
        case 'b': // borders
          config.borders = items.map(item => {
            const [position, color] = item.split('-');
            return { position, color };
          });
          break;
        case 'c': // corner blocks
          config.corners = items.map(item => {
            const [position1, position2, color] = item.split('-');
            return { position1, position2, color };
          });
          break;
        case 't': // border tips
          config.tips = items.map(item => {
            const [position1, position2, color] = item.split('-');
            return { position1, position2, color };
          });
          break;
        case 'n': // number
          config.number = items[0]
          break;
      }
    });

    return config;
  }

  private createBorders(container: HTMLElement, borders: Array<{position: string, color: string}>): void {
    borders.forEach(({position, color}) => {
      const border = document.createElement('div');
      border.className = `border border--${position} border--${color}`;
      container.appendChild(border);
    });
  }

  private createCornerBlocks(container: HTMLElement, corners: Array<{position1: string, position2: string, color: string}>): void {
    corners.forEach(({position1, position2, color}) => {
      const corner = document.createElement('div');
      corner.className = `corner-block corner-block--${position1} corner-block--${position2} corner-block--${color}`;
      container.appendChild(corner);
    });
  }

  private createBorderTips(container: HTMLElement, tips: Array<{position1: string, position2: string, color: string}>): void {
    tips.forEach(({position1, position2, color}) => {
      const tip = document.createElement('div');
      tip.className = `border-tip border-tip--${position1}-${position2} border-tip--${color}`;
      container.appendChild(tip);
    });
  }

  private createNumber(container: HTMLElement, number: string): void {
    if(!number) return;
    const numberElement = document.createElement('div');
    numberElement.className = `number-element`;
    numberElement.textContent = number;
    container.appendChild(numberElement);
  }
}

export default function borderContainer() {
  return new BorderContainer();
}